module.exports = __webpack_public_path__ + "img/centos_logo.badb274b.svg";